import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromShared from './process.reducer';
import { adapter } from './process.reducer';

export const selectProcessState = createFeatureSelector<fromShared.State>(
    fromShared.processesFeatureKey
);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = adapter.getSelectors(selectProcessState);

export const selectCurrent = createSelector(selectAll, x => x[0]);
